import type { User } from '../../types/session';
import getCurrentHostname from '../../utils/getCurrentHostname';

const handleUserSession = async (user?: User | null): Promise<void> => {
  const { href } = window.location;

  if (!user) {
    return window.location.assign(
      `${getCurrentHostname()}/v2/api/session/signin?redirect=${encodeURIComponent(href)}`
    );
  }

  return window.location.assign(`${getCurrentHostname()}/v2/api/session/signout`);
};

export default handleUserSession;
